import Tilt from "react-parallax-tilt";
import { useMotionConfig } from "../motion/useMotionConfig";

/**
 * Wraps children in a subtle 3D tilt on hover (desktop only). On mobile or
 * reduced-motion it renders children untouched.
 */
export default function TiltCard({ children, glare = true, max = 8, style }) {
  const { lightMode } = useMotionConfig();

  if (lightMode) {
    return <div style={style}>{children}</div>;
  }

  return (
    <Tilt
      tiltMaxAngleX={max}
      tiltMaxAngleY={max}
      glareEnable={glare}
      glareMaxOpacity={0.18}
      glareColor="#bcd0ff"
      glarePosition="all"
      glareBorderRadius="20px"
      transitionSpeed={1400}
      scale={1.02}
      style={{ height: "100%", ...style }}
    >
      {children}
    </Tilt>
  );
}
